import React, { useState, useRef, useEffect } from "react";
import styles from "../../../styles.module.scss";

const RefundItemAccordion = ({isDisabled ,  children = [] }) => {

    const [isExpanded, setExpanded] = useState(false);
    const [height, setHeight] = useState(0);

    const [summaryComp, detailsComp] = React.Children.toArray(children);

    const contentRef = useRef(null);

    const toggleExpansion = (e) => {
        if(e.target.type === 'checkbox'){ 
            setExpanded(e.target.checked); //handling expansion based on the refund item selection
            return;
        }

        setExpanded(prev => !prev);
    }

    useEffect(() => {
        if (isExpanded) {
            setHeight(contentRef.current.scrollHeight + 10);
        } else {
            setHeight(0);
        }
    }, [isExpanded]);

    return (
        <div className={`${styles["refund-item-accordion"]} ${isDisabled ? styles['accordion-disabled'] : ''}`}>
            <div
                className={styles["refund-summary"]}
                onClick={toggleExpansion}
            >
                {summaryComp}
            </div>

            <div
                ref={contentRef}
                className={styles["refund-details"]}
                style={{
                    height: `${height}px`,
                    overflow: "hidden",
                    transition: "height 0.3s ease"
                }}
            >
                {detailsComp}
            </div>
        </div>
    );
};

export default RefundItemAccordion;
